<template>
		<!-- 基本功能下的户型管理下的新增户型 -->
  <div class="role-info app-region blank-t-v blank-b-v blank-l-h blank-r-h">
    <!-- form表单 -->
	<a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
      <a-form-model-item label="户型名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入户型名称" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="建筑面积" prop="buildArea">
        <a-input type="number" :min="0" v-model="form.buildArea" placeholder="请输入建筑面积">
          <p slot="addonAfter">㎡</p>
        </a-input>
      </a-form-model-item>
      <a-form-model-item label="套内面积" prop="insideArea">
        <a-input type="number" :min="0" v-model="form.insideArea" placeholder="请输入套内面积">
          <p slot="addonAfter">㎡</p>
        </a-input>
      </a-form-model-item>
      <a-form-model-item label="公摊面积" prop="shareArea">
        <a-input type="number" :min="0" v-model="form.shareArea" placeholder="请输入公摊面积">
          <p slot="addonAfter">㎡</p>
        </a-input>
      </a-form-model-item>
      <a-form-model-item label="赠送面积" prop="freeArea">
        <a-input type="number" :min="0" v-model="form.freeArea" placeholder="请输入赠送面积">
          <p slot="addonAfter">㎡</p>
        </a-input>
      </a-form-model-item>
      <a-form-model-item label="户型信息" prop="room">
        <a-input type="number" :min="0" v-model="form.room" placeholder="请输入室">
          <p slot="addonAfter">室</p>
        </a-input>
      </a-form-model-item>
      <a-form-model-item label="户型信息" prop="office">
        <a-input type="number" :min="0" v-model="form.office" placeholder="请输入厅">
          <p slot="addonAfter">厅</p>
        </a-input>
      </a-form-model-item>
      <a-form-model-item label="户型信息" prop="toilet">
        <a-input type="number" :min="0" v-model="form.toilet" placeholder="请输入卫">
          <p slot="addonAfter">卫</p>
        </a-input>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="submit">提交</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
  import HouseTypeService from '@/io/house_type.js';
  
  export default {
    name: 'HouseTypeInfo',
    data() {
      return {
        communityId: this.$route.query.community_id,
        id: this.$route.params.id,
        form: {
          name: null,
          buildArea: 0,
          insideArea: 0,
          shareArea: 0,
          freeArea: 0,
          room: 0,
          office: 0,
          toilet: 0
        },
        rules: {
          name: [
            {
              required: true,
              message: '请输入户型名称'
            }
          ],
          buildArea: [
            {
              required: true,
              message: '请输入建筑面积'
            }
          ],
          insideArea: [
            {
              required: true,
              message: '请输入套内面积'
            }
          ],
          shareArea: [
            {
              required: true,
              message: '请输入公摊面积'
            }
          ],
          freeArea: [
            {
              required: true,
              message: '请输入赠送面积'
            }
          ],
          room: [
            {
              required: true,
              message: '请输入室'
            }
          ],
          office: [
            {
              required: true,
              message: '请输入厅'
            }
          ],
          toilet: [
            {
              required: true,
              message: '请输入卫'
            }
          ],
        }
      }
    },
    mounted () {
      this.initPage();
    },
    methods: {
      initPage() {
        if (this.id) {
          HouseTypeService.info(this.id).then(res => {
            this.form.name = res.name;
            this.form.buildArea = res.build_area;
            this.form.insideArea = res.use_area;
            this.form.shareArea = res.public_area;
            this.form.freeArea = res.gift_area;
            this.form.room = res.room;
            this.form.office = res.hall;
            this.form.toilet = res.toilet;
          }).catch(err => {});
        }
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          if (this.id) {
            HouseTypeService.edit(
              this.id,
              this.communityId,
              this.form.name,
              this.form.buildArea,
              this.form.insideArea,
              this.form.shareArea,
              this.form.freeArea,
              this.form.room,
              this.form.office,
              this.form.toilet
            ).then(res => {
              this.$afterFormSubmit('编辑成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          } else {
            HouseTypeService.add(
              this.communityId,
              this.form.name,
              this.form.buildArea,
              this.form.insideArea,
              this.form.shareArea,
              this.form.freeArea,
              this.form.room,
              this.form.office,
              this.form.toilet
            ).then(res => {
              this.$afterFormSubmit('创建成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          }
        });
      },
      cancel() {
        this.$router.push({
          name: 'HouseTypeManage'
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>